import React, { useState } from "react";
import { Button } from "~views/shared";
import crossIcon from "~assets/cross.svg";
import checkmark from "~assets/checkmark_green.svg";
import errorIcon from "~assets/error.svg";
import { IAttachment } from "netbank-shared/src/libs/models/Attachment/Attachment";
import styles from "./FileAttachment.scss";
import rootStyles from "~views/pages/Root.scss";
import classNames from "classnames";

interface IFileCardProps {
  attachment: IAttachment & { status: string };
  removeAttachment: (id: string) => Promise<void>;
  disabled?: boolean;
}

export const FileCard = ({ attachment, removeAttachment, disabled }: IFileCardProps) => {
  const [removing, setRemoving] = useState(false);

  const onRemove = async () => {
    try {
      setRemoving(true);
      await removeAttachment(attachment.id);
    } finally {
      setRemoving(false);
    }
  };

  let statusText = "Uploaded";
  if (attachment.status === "uploading") {
    statusText = "Uploading...";
  } else if (attachment.status === "error") {
    statusText = "Error";
  } else if (removing) {
    statusText = "Removing...";
  }

  const isLoading = attachment.status === "uploading" || removing;

  return (
    <div className={styles.attachmentCard}>
      <div className={styles.icon}>
        {!removing && attachment.status === "done" && <img src={checkmark} alt="" />}
        {!removing && attachment.status === "error" && <img src={errorIcon} alt="" />}
        {isLoading && <div className={classNames(rootStyles.spinner, styles.spinner, rootStyles.loading)} />}
      </div>
      <div className={styles.detailsContainer}>
        <h5>{attachment.name}</h5>
        <div className={styles.fileStatus}>{statusText}</div>
      </div>
      <Button
        disabled={disabled || isLoading}
        type="text"
        onClick={() => {
          onRemove();
        }}
        className={styles.closeButton}
        iconPrefix={crossIcon}
      />
    </div>
  );
};
